import create from 'zustand';
import produce from 'immer';

const GRADE_CREATE_INITIAL = {
	grade: {
		title: '',
		titlePublic: '',
		programId: 0,
		number: '',
		price: ''
	}
};

export const useGradeCreateStore = create(set => ({
	...GRADE_CREATE_INITIAL,

	// Handle state change
	onChange: ({ name, value }) => set(produce(state => {
		state.grade[name] = value;
	})),

	// Reset store to initial state
	onReset: () => set({
		...GRADE_CREATE_INITIAL
	})
}));